import { MbscRangeOptions, MbscCalendarOptions } from '@mobiscroll/angular';

/*
 * For more option settings, please refer to this page
 * https://docs.mobiscroll.com/angular/range#options
 * */

export const MBSRangeConfig: MbscRangeOptions = {
  dateFormat: 'D, d M yy',
  display: 'center',
  weekDays: 'short',
  buttons: [],
  autoCorrect: true,
  showOnFocus: true,
  setText: 'Set',
  cancelText: 'Cancel',
  months: 'auto',
  yearChange: false,
};

export const MBSDateConfig: MbscCalendarOptions = {
  dateFormat: 'D, d M yy',
  display: 'center',
  weekDays: 'short',
  buttons: [],
  setText: 'Set',
  cancelText: 'Cancel',
  showOnFocus: true,
};

export const MBSDropDownConfig: MbscCalendarOptions = {
  dateFormat: 'd M yy',
  display: 'center',
  buttons: [],
  showOnFocus: true,
  controls: ['date'],
};

export const defaultPickerConfig: MbscCalendarOptions | MbscRangeOptions = {
  display: 'center',
  buttons: [],
  showOnFocus: true,
  theme: 'whiteLabel',
  cssClass: `nibtravel`,
};
